<div class="container-fluid">
    <div class="row" style="border-bottom:1px solid white;background:#057cfe;color:white;">
        <div class="header">
            <a *ngFor="let item of navItems" (click)="renderContent(item)" style="cursor: pointer;color: white;text-decoration: none;">{{item.attributes.name}}</a>
            <a style="display: flex;justify-content: center;align-items: center;text-decoration: none;" (click)="switchLanguage()"><img [src]="flag" alt="locale"></a>
        </div>
    </div>
</div>
